import storeInfo from '../store'
import { MaterialItem } from '../types'

export const getMaterial = (): MaterialItem => {
  const { material } = storeInfo.store.getState()
  return material
}
